import React, { useState } from 'react';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';

import './index.css';

type DropdownProps = {
    className?: string;
    data: any[];
    dataKey?: string;
    disabled?: boolean;
    onSelect: (value: any) => void;
    label?: string;
    placeholder?: string;
    required?: boolean;
    value?: any;
}

function Dropdown({
    className,
    data,
    dataKey,
    disabled,
    onSelect,
    label,
    placeholder,
    required,
    value
}: DropdownProps) {
    const [isOpen, setIsOpen] = useState(false);

    const ref = useOutsideClickHandler(() => setIsOpen(false));

    const selectItem = (item: any) => {
        onSelect(item);
        setIsOpen(false);
    }

    return (
        <div
            className={disabled
                ? `dropdown2--disabled ${className}`
                : isOpen
                ? `dropdown2--open ${className}`
                : `dropdown2 ${className}`
            } 
            ref={ref}
        >
            {label &&
                <p className='dropdown2__label'>
                    {label} {required && '*'}
                </p>
            }
            <div className='dropdown2__value' onClick={() => !disabled && setIsOpen(!isOpen)}>
                {value
                    ?   <p>{value.replace('ACT ', '').replace('Mathematics', 'Math')}</p>
                    :   placeholder
                    ?   <p className='dropdown2__placeholder'>
                            {placeholder}
                        </p>
                    :   ''
                }
                {!disabled && isOpen &&
                    <div className='dropdown2__items'>
                        {data.map((item, i) => (
                            <p
                                key={i} 
                                className='dropdown2__item'
                                onClick={() => selectItem(item)}
                            >
                                {dataKey ? item[dataKey].replace('ACT ', '').replace('Mathematics', 'Math') : item.replace('ACT ', '').replace('Mathematics', 'Math')}
                            </p>
                        ))}
                    </div>
                }
                {isOpen
                    ? <FaChevronUp className='dropdown2__icon' />
                    : <FaChevronDown className='dropdown2__icon' />
                }
            </div>
        </div>
    );
}

export default Dropdown;